import type { CSSProperties } from "react"

/**
 * CSS for showing a single cell of a one-row sprite strip, scaled to fill its box.
 *
 * Percentage `background-position` resolves against (container size - image size),
 * so for an N-cell strip blown up to N x the container width the step between
 * cells is 100 / (N - 1) percent. Several call sites used `index * -100%`, which
 * pushed every cell but the first far off-screen - tower portraits in the codex
 * only looked right for the archer (index 0) and enemy portraits rendered blank.
 */
export const spriteStripStyle = (spriteIndex: number, cellCount: number): CSSProperties => ({
  backgroundPosition: cellCount > 1 ? `${(spriteIndex * 100) / (cellCount - 1)}% 0` : "0 0",
  backgroundSize: `${cellCount * 100}% 100%`,
  backgroundRepeat: "no-repeat",
  imageRendering: "pixelated",
})
